import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=2eef145a&scoped=true"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"
import style0 from "./Inspection.vue?vue&type=style&index=0&id=2eef145a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef145a",
  null
  
)

export default component.exports